import { Link, useLocation } from "react-router-dom";
import menu from "../assets/images/Hamburger_LG.svg";
import { useState } from "react";
import DropDownMenu from "./dropdownMenu";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useEffect, useRef } from "react";

const Header = () => {
  const [showDrop, setIshowDrop] = useState<boolean>(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const title = process.env.REACT_APP_TITLE;
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const DropdownItem = ({
    currentPath,
    to,
    label,
    onClick,
  }: {
    currentPath: string;
    to: string;
    label: string;
    onClick: () => void;
  }) => {
    return (
      <li>
        <Link
          to={to}
          className={`block px-4 py-2 text-sm hover:bg-purple-50 ${
            currentPath === to
              ? "text-[#7F55DA] font-semibold"
              : "text-gray-700"
          }`}
        >
          {label}
        </Link>
      </li>
    );
  };

  return (
    <div className="w-full relative">
      <header className=" h-[98px] border-b-2 border-[#d6d6d6] justify-center  flex w-full items-center bg-white max-w-[1750px] mx-auto lg:px-[100px] px-[24px] ">
        <div className="w-full  flex justify-between items-center">
          <h2 className="text-[#7F55DA]  text-2xl leading-6 font-semibold font-Poppins">
            <Link to={"/"}>{title}</Link>
          </h2>
          <nav className="xl:block hidden">
            <ul className="flex gap-8 items-center text-[#525252] text-[16px] leading-6 font-normal font-Poppins list-none cursor-pointer">
              <li className="relative" ref={dropdownRef}>
                <button
                  className={`flex items-center gap-1 ${
                    currentPath.startsWith("/map")
                      ? "text-[#7F55DA] font-semibold"
                      : ""
                  }`}
                  onClick={() => setIsOpen(!isOpen)}
                  aria-expanded={isOpen}
                  aria-haspopup="true"
                >
                  Explore
                  {isOpen ? (
                    <ChevronUp className="h-4 w-4" />
                  ) : (
                    <ChevronDown className="h-4 w-4" />
                  )}
                </button>

                {isOpen && (
                  <ul
                    className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10"
                    role="menu"
                  >
                    <DropdownItem
                      currentPath={currentPath}
                      to="/companies/view"
                      label="Companies"
                      onClick={() => setIsOpen(false)}
                    />
                    <DropdownItem
                      currentPath={currentPath}
                      to="/people/view"
                      label="Peoples"
                      onClick={() => setIsOpen(false)}
                    />
                    <DropdownItem
                      currentPath={currentPath}
                      to="/document/view"
                      label="Documents"
                      onClick={() => setIsOpen(false)}
                    />
                    <DropdownItem
                      currentPath={currentPath}
                      to="/site/view"
                      label="Sites"
                      onClick={() => setIsOpen(false)}
                    />
                    <DropdownItem
                      currentPath={currentPath}
                      to="/mineral/view"
                      label="Minerals"
                      onClick={() => setIsOpen(false)}
                    />
                  </ul>
                )}
              </li>
              <li
                className={`${
                  currentPath === "/map" ? "text-[#7F55DA] font-semibold" : ""
                }`}
              >
                <Link to={"/map"}>Interactive Map</Link>
              </li>
              <li
                className={`${
                  currentPath === "/country-overview"
                    ? "text-[#7F55DA] font-semibold"
                    : ""
                }`}
              >
                <Link to={"/country"}>Country Overview</Link>
              </li>
              <li
                className={`${
                  currentPath === "/regulation"
                    ? "text-[#7F55DA] font-semibold"
                    : ""
                }`}
              >
                <Link to={"/regulation"}>Regulation & Policies</Link>
              </li>
              <li
                className={`${
                  currentPath === "/License"
                    ? "text-[#7F55DA] font-semibold"
                    : ""
                }`}
              >
                <Link to={"/License"}>Licenses</Link>
              </li>
              <li
                className={`${
                  currentPath === "/reports"
                    ? "text-[#7F55DA] font-semibold"
                    : ""
                }`}
              >
                <Link to={"/reports"}>Investigations & Reports</Link>
              </li>
              {/**
              <li
                className={`${
                  currentPath === "/data" ? "text-[#7F55DA] font-semibold" : ""
                }`}
              >
                <Link to={"/data"}>Data & Visualization</Link>
              </li>
              */}
            </ul>
          </nav>
          <img
            src={menu}
            alt=""
            className="h-6 xl:hidden block cursor-pointer"
            onClick={() => setIshowDrop(!showDrop)}
          />
        </div>
      </header>

      {showDrop && <DropDownMenu setIshowDrop={setIshowDrop} />}
    </div>
  );
};

export default Header;
